import {
  FETCH_MEMBER_ADCARDS_FAIL,
  FETCH_MEMBER_ADCARDS_REQUEST,
  FETCH_MEMBER_ADCARDS_SUCCESS,
  PROMOTED_BY,
  RESET_PROMOTED_BY,
} from "../constants";

export const adCardReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_MEMBER_ADCARDS_REQUEST:
      return { loading: true };
    case FETCH_MEMBER_ADCARDS_SUCCESS:
      return { adcards: action.payload, loading: false };
    case FETCH_MEMBER_ADCARDS_FAIL:
      return { error: action.payload, loading: false };
    case PROMOTED_BY:
      return { member_user: action.payload, loading: false };
    case RESET_PROMOTED_BY:
      return {};
    default:
      return state;
  }
};
